import React from "react";
import PropTypes from "prop-types";

import { Alert } from "react-bootstrap";

export default function CustomAlert({ children, type, className, show }) {
  if (!show) {
    return null;
  }
  return (
    <Alert bsStyle={type} className={className}>
      {children}
    </Alert>
  );
}

CustomAlert.propTypes = {
  children: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
  show: PropTypes.bool
};

CustomAlert.defaultProps = {
  type: "warning",
  className: ""
};
